import React from 'react'
import wedding from "../images/WEDDING SLIDER.jpg";

import diwali from "../images/Diwali Wish Website update.jpg"
import trendingdress_women from "../images/DURGA PUJA 2025 BANNER NEW.jpg";
import pujatrendingdress_women from "../images/DURGA PUJA 2025 BANNER printed dress.jpg"

function MainSlider() {
  return (
    <div>
        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
        <div className='sareekarimpur'>
      <img src={wedding} className="d-block w-100" alt="wedding-collection"/>
    </div>
    </div>
    <div className="carousel-item">
             <div className='sareekarimpur'>
      <img src={diwali} className="d-block w-100" alt="#best saree collection"/>
      </div>
    </div>
    <div className="carousel-item">
             <div className='sareekarimpur'>
      <img src={pujatrendingdress_women} className="d-block w-100" alt="#best saree collection"/>
      </div>
    </div>
    <div className="carousel-item">
          <div className='sareekarimpur'>
      <img src={trendingdress_women} className="d-block w-100" alt="trendingdress_women"/>
      </div>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default MainSlider